module.exports = __webpack_public_path__ + "img/Team-JarrodHough.b25ef470.png";